/**
 * Endpoints exclusivos para el panel administrativo
 */
export const ADMIN_API_ENDPOINTS = {
    ARTICLES: {
        BASE: '/api/articles',
        BY_ID: (id) => `/api/articles/${id}`,
        UPDATE: (id) => `/api/articles/${id}/update`,
        BY_PARENT: (parentId) => `/api/articles/by-parent/${parentId}`
    },
    LOCATIONS: {
        BASE: '/api/locations',
        BY_ID: (id) => `/api/locations/${id}`,
        BY_USER: (userId) => `/api/locations/by-user/${userId}`,
        UPDATE: (id) => `/api/locations/${id}/update`
    },
    LOCATION_IMAGES: {
        BASE: '/api/location-images',
        BY_ID: (id) => `/api/location-images/${id}`,
        SET_MAIN: (id) => `/api/location-images/${id}/set-main`,
        BY_USER: (userId) => `/api/location-images/by-user/${userId}`,
    },
    LOCATION_ITEMS: {
        BASE: '/api/location-items',
        BY_ID: (id) => `/api/location-items/${id}`,
        BY_USER: (userId) => `/api/location-items/by-user/${userId}`,
    },
    LOCATION_SUBCATEGORIES: {
        BASE: '/api/location-subcategories',
        BY_LOCATION: (locationId) => `/api/location-subcategories/${locationId}`,
        BY_LOCATION_AND_SUBCATEGORY: (locationId, subcategoryId) => `/api/location-subcategories/${locationId}/${subcategoryId}`,
    },
    LOCATION_REVIEWS: {
        BASE: '/api/location-reviews',
        BY_ID: (id) => `/api/location-reviews/${id}`,
        BY_LOCATION: (locationId) => `/api/location-reviews/by-location/${locationId}`
    },
    LOCATION_POLICIES: {
        BASE: '/api/location-policies',
        BY_ID: (id) => `/api/location-policies/${id}`,
        BY_LOCATION: (locationId) => `/api/location-policies/by-location/${locationId}`,
        BY_USER: (userId) => `/api/location-policies/by-user/${userId}`,
        UPDATE_OR_CREATE: (locationId) => `/api/location-policies/by-location/${locationId}/update-or-create`
    },
    CATEGORIES: {
        BASE: '/api/categories',
        BY_ID: (id) => `/api/categories/${id}`,
        UPDATE: (id) => `/api/categories/${id}/update`
    },
    SUBCATEGORIES: {
        BASE: '/api/subcategories',
        BY_ID: (id) => `/api/subcategories/${id}`,
        UPDATE: (id) => `/api/subcategories/${id}/update`
    },
    USERS: {
        BASE: '/api/users',
        BY_ID: (id) => `/api/users/${id}`,
        UPDATE: (id) => `/api/users/${id}`,
        TOGGLE_STATUS: (id) => `/api/users/${id}/toggle-status`
    },
    PLANS: {
        BASE: '/api/plans',
        BY_ID: (id) => `/api/plans/${id}`,
        ACTIVE: '/api/plans/active',
        TOGGLE_ACTIVE: (id) => `/api/plans/${id}/toggle-active`
    }
};
export default ADMIN_API_ENDPOINTS;
